import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  partners: [],
  campaignsCatalog: {},
  selected: {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
